"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRIPE_HOMEPAGE_CHECKOUT_SESSION = exports.CUSTOMER_PORTAL = void 0;
const client_1 = require("@apollo/client");
exports.CUSTOMER_PORTAL = (0, client_1.gql) `
  mutation CustomerPortal {
    customerPortal
  }
`;
exports.STRIPE_HOMEPAGE_CHECKOUT_SESSION = (0, client_1.gql) `
  mutation StripeHomepageCheckoutSession($lineItems: [LineItemInput!]!) {
    stripeHomepageCheckoutSession(lineItems: $lineItems)
  }
`;
